export const ANSI_STYLES: Record<number, Record<string, string>> = {
  // Text styles
  0: {}, // reset all styles
  1: { 'font-weight': 'bold' }, // bold
  21: { 'font-weight': 'normal' }, // reset bold
  2: { opacity: '0.5' }, // dim
  22: { 'font-weight': 'normal', opacity: '1.0' }, // reset dim
  3: { 'font-style': 'italic' }, // italic
  23: { 'font-style': 'normal' }, // reset italic
  4: { 'text-decoration': 'underline' }, // underline
  24: { 'text-decoration': 'none' }, // reset underline
  // 5: {}, // blink, not widely supported
  // 25: {}, // reset blink
  // 6: {}, // fast blink, not widely supported
  // 26: {}, // reset fast blink
  // 7: {}, // invert colors
  // 27: {}, // reset invert colors
  8: { opacity: '0.0' }, // hidden
  28: { opacity: '1.0' }, // reset hidden
  9: { 'text-decoration': 'line-through' }, // strikethrough
  29: { 'text-decoration': 'none' }, // reset strikethrough

  // Standard foreground colors - using more saturated versions
  30: { color: 'var(--colors-neutral-10)' }, // black
  31: { color: 'var(--colors-red-60)' }, // red
  32: { color: 'var(--colors-green-60)' }, // green
  33: { color: 'var(--colors-yellow-80)' }, // yellow
  34: { color: 'var(--colors-blue-60)' }, // blue
  35: { color: 'var(--colors-purple-60)' }, // magenta
  36: { color: 'var(--colors-turquoise-60)' }, // cyan
  37: { color: 'var(--colors-neutral-100)' }, // white
  39: { color: 'var(--colors-neutral-100)' }, // default

  // Bright foreground colors - using lighter versions
  90: { color: 'var(--colors-neutral-50)' }, // bright black
  91: { color: 'var(--colors-red-80)' }, // bright red
  92: { color: 'var(--colors-green-80)' }, // bright green
  93: { color: 'var(--colors-yellow-90)' }, // bright yellow
  94: { color: 'var(--colors-blue-80)' }, // bright blue
  95: { color: 'var(--colors-purple-80)' }, // bright magenta
  96: { color: 'var(--colors-turquoise-80)' }, // bright cyan
  97: { color: 'var(--colors-neutral-100)' }, // bright white
  99: { color: 'var(--colors-neutral-100)' }, // default

  // Background colors - using darker versions for better contrast
  40: { 'background-color': 'var(--colors-neutral-10)' }, // black
  41: { 'background-color': 'var(--colors-red-30)' }, // red
  42: { 'background-color': 'var(--colors-green-30)' }, // green
  43: { 'background-color': 'var(--colors-yellow-30)' }, // yellow
  44: { 'background-color': 'var(--colors-blue-30)' }, // blue
  45: { 'background-color': 'var(--colors-purple-30)' }, // magenta
  46: { 'background-color': 'var(--colors-turquoise-30)' }, // cyan
  47: { 'background-color': 'var(--colors-neutral-100)' }, // white
  49: { 'background-color': 'var(--colors-neutral-10)' }, // default

  // Bright background colors - using medium versions
  100: { 'background-color': 'var(--colors-neutral-50)' }, // bright black
  101: { 'background-color': 'var(--colors-red-50)' }, // bright red
  102: { 'background-color': 'var(--colors-green-50)' }, // bright green
  103: { 'background-color': 'var(--colors-yellow-50)' }, // bright yellow
  104: { 'background-color': 'var(--colors-blue-50)' }, // bright blue
  105: { 'background-color': 'var(--colors-purple-50)' }, // bright magenta
  106: { 'background-color': 'var(--colors-turquoise-50)' }, // bright cyan
  107: { 'background-color': 'var(--colors-neutral-100)' }, // bright white
  109: { 'background-color': 'var(--colors-neutral-50)' }, // default
};
